import { render, staticRenderFns } from "./technologyVideo.vue?vue&type=template&id=45cd9521&scoped=true"
import script from "./technologyVideo.vue?vue&type=script&lang=js"
export * from "./technologyVideo.vue?vue&type=script&lang=js"
import style0 from "./technologyVideo.vue?vue&type=style&index=0&id=45cd9521&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cd9521",
  null
  
)

export default component.exports